import { ObjectSchema } from "yup";
import { TConfiguracaoFormularioIdeias } from "@/modules/configuracao-formulario-ideias";
import schema from "@/schema";
import { TIdeiaForm } from "../firestore";
import ideiaSchema from "./ideia-schema";

/**
 * Gera um schema dinâmico baseado na configuração do formulário de ideias
 * Campos não visíveis são tornados opcionais
 * @param configuracao
 */
export function getDynamicIdeiaSchema(configuracao?: TConfiguracaoFormularioIdeias): ObjectSchema<TIdeiaForm> {
  if (!configuracao) {
    return ideiaSchema;
  }

  let dynamicSchema = ideiaSchema;
  const shapeOverrides: Record<string, any> = {};

  if (!configuracao.objetivo?.visivel) {
    shapeOverrides.objetivo = schema.array().of(schema.mixed().optional()).optional().default([]);
  }

  if (!configuracao.setores?.visivel) {
    shapeOverrides.setores = schema.array().of(schema.string().optional()).optional().default([]);
  }

  if (Object.keys(shapeOverrides).length > 0) {
    dynamicSchema = dynamicSchema.shape(shapeOverrides) as ObjectSchema<TIdeiaForm>;
  }

  return dynamicSchema;
}
